import { render, staticRenderFns } from "./linkService.vue?vue&type=template&id=0ce6acc2&scoped=true&"
import script from "./linkService.vue?vue&type=script&lang=js&"
export * from "./linkService.vue?vue&type=script&lang=js&"
import style0 from "./linkService.vue?vue&type=style&index=0&id=0ce6acc2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce6acc2",
  null
  
)

export default component.exports